module.exports = __webpack_public_path__ + "static/media/EXPO.828f3449.svg";